import QueryUtils from "@/utils/QueryUtils";
import axios, {AxiosResponse} from "axios";
import {Filter} from "@/dto/Pageable";
import Page from "@/dto/taxation/Page";
import {SERVICE_ENDPOINT} from "@/constants/endpoints";
import authHeader from "@/services/auth-header";
import {
    CreateServicePayload,
    ServiceDTO,
    UpdateServicePayload
} from "@/components/payroll/business/services/ServiceDTO";

class ServiceOrchestrator {

    public getPageByFilter<T extends Filter>(filter: T) {
        const query = QueryUtils.objectToQueryString(filter);
        return axios.get<Page<ServiceDTO>>(`${SERVICE_ENDPOINT}${query}`, {headers: authHeader()})
    }

    public getById(id: number | string): Promise<AxiosResponse<ServiceDTO>> {
        return axios.get<ServiceDTO>(`${SERVICE_ENDPOINT}/${id}`, {headers: authHeader()})
    }

    public createService(payload: CreateServicePayload) {
        return axios.post<ServiceDTO>(`${SERVICE_ENDPOINT}`, payload, {headers: authHeader()})
    }

    public updateService(payload: UpdateServicePayload): Promise<AxiosResponse<ServiceDTO>> {
        return axios.put<ServiceDTO>(`${SERVICE_ENDPOINT}`, payload, {headers: authHeader()})
    }

    public disableService(serviceId: number | string, companyId: number | string | null) {
        return axios.delete<void>(`${SERVICE_ENDPOINT}/${companyId}/${serviceId}`, {headers: authHeader()})
    }

    public getRecentServices(executorId: number, recipientId: number) {
        return axios.get<Page<ServiceDTO>>(`${SERVICE_ENDPOINT}/recent?executorId=${executorId}&recipientId=${recipientId}`, {headers: authHeader()})
    }

}

export default new ServiceOrchestrator();
